import React from "react";
import { createAuthServer, updateAuthServer } from "../authService";

export const CardTypes = {
    CREATE: "CREATE",
    EDIT: "EDIT"
}

export class AuthServerCardService {

    constructor(cardType, handleClose) {
        this.cardType = cardType || CardTypes.CREATE;
        this.handleClose = handleClose;
    }

    getHeader = () => {
        return (
            <div className="logo text-center">
                {CardTypes.CREATE === this.cardType ? 'New' : 'Edit'} Authentication Server
            </div>
        )
    }

    getSubmitButton = (data, disabled) => {
        if (CardTypes.CREATE === this.cardType) {
            return (
                <div className="form-group text-center">
                    <button type="submit" className="btn oct_btn-login" onClick={(e) => {
                        e.preventDefault();
                        this.onCreate(data);
                    }} disabled={disabled}>Create
                    </button>
                </div>
            )
        } else {
            return (
                <>
                    <div className="form-group text-center">
                        <button type="submit" className="btn oct_btn-login" onClick={(e) => {
                            e.preventDefault();
                            this.onSave(data);
                        }} disabled={disabled}>Save
                        </button>
                    </div>
                    {/* {data.id === this.loggedUserId &&
                    <div className="text-center text-warning mb-1">
                        You will be logged out after any changes
                    </div> */}
                    {/* } */}
                </>
            )
        }
    }

    getCheckButton = (data) => {

        return (
            <div className="form-group text-center">
                <button type="submit" className="btn oct_btn-login" onClick={(e) => {
                    e.preventDefault();
                    this.checkConnectivity(data);
                }}> Check Connectivity
                </button>
            </div>
        )
    }

    onCreate = async (data) => {
        await createAuthServer(data);
        this.handleClose(true);
    }

    onSave = async (data) => {
        await updateAuthServer(data);
        this.handleClose(true);
    }

}
